import { useTheme } from '@emotion/react';
import styled from '@emotion/styled';
import React, { useEffect, useRef } from 'react';

import { withSpacingStyles } from '../withSpacingStyles';
import { Icon, useComponentTheme } from '..';
import { useTranslation } from 'react-i18next';

type Props = {
  className?: Node,
  color?: string,
  position?: string,
  dataTest?: string,
  top?: string,
  autoFocus?: boolean,
};

export const Loader = withSpacingStyles(({ className, color, position, dataTest, top, autoFocus }: Props) => {
  const theme = useTheme();
  const { t } = useTranslation('common');
  const ref = useRef(null);
  const componentTheme = useComponentTheme(theme => theme.components.Loader, 'default');

  useEffect(() => {
    if (autoFocus && ref.current) {
      ref.current.focus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Wrapper
      ref={ref}
      className={className}
      position={position}
      data-test={dataTest}
      top={top}
      aria-label={t('loading')}
      {...(autoFocus && { tabIndex: -1 })}
    >
      {componentTheme.svg ? (
        <Img data={componentTheme.svg} />
      ) : (
        <Icon name="Loader" fill={color || componentTheme.color || theme.color.brand} size={100} spin />
      )}
    </Wrapper>
  );
});

const Wrapper = styled('div')`
  outline: none;
  position: ${({ position }) => position};
  top: ${({ top }) => top};
  left: 0;
  right: 0;
  margin: 0 auto;
  text-align: center;
  max-width: 100px;
  max-height: 100px;
`;

const Img = styled('object')`
  max-width: 100px;
  max-height: 100px;
`;

Loader.defaultProps = {
  position: 'absolute',
  top: '40%',
};

Loader.displayName = 'Loader';
